import React from "react";
import { Spin } from "antd";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import OrganisationCaseLawDocumentTypeGrid from "../components/OrganisationCaseLawDocumentTypeGrid";
import { IOrganisationCaseLawDocumentTypesPresenter } from "../../../organisations/presenter/OrganisationCaseLawDocumentTypePresenter";

export interface Props extends PageProps {}

export interface State extends IOrganisationCaseLawDocumentTypesPresenter {}

export default class OrganisationCaseLawDocumentTypePage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      onChangeAddElementsModalVisible,
      modalVisible,
      addCaseLawDocumentTypeIndexCategories,
      organisationIndexCategories,
      currentCaseLawDocumentTypeId,
      caseLawDocumentTypeIndexCategories,
      organisationCaseLawDocumentTypes,
      organisationId,
      addCaseLawDocumentTypeToOrganisation,
      onChangeAddTypesToOrganisationModalVisible,
      setOrganisationCaseLawDocumentTypeData,
      caseLawDocumentTypes,
      assignTypesToOrganisationModalVisible,
      removeOrganisationCaseLawDocumentType
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.organisationCaseLawDocumentType}>
            <OrganisationCaseLawDocumentTypeGrid
              removeOrganisationCaseLawDocumentType={
                removeOrganisationCaseLawDocumentType
              }
              caseLawDocumentTypeIndexCategories={
                caseLawDocumentTypeIndexCategories
              }
              organisationCaseLawDocumentTypes={
                organisationCaseLawDocumentTypes
              }
              organisationId={organisationId}
              translate={translate}
              onChangeAddElementsModalVisible={onChangeAddElementsModalVisible}
              modalVisible={modalVisible}
              addCaseLawDocumentTypeIndexCategories={
                addCaseLawDocumentTypeIndexCategories
              }
              organisationIndexCategories={organisationIndexCategories}
              currentCaseLawDocumentTypeCode={currentCaseLawDocumentTypeId}
              addCaseLawDocumentTypeToOrganisation={
                addCaseLawDocumentTypeToOrganisation
              }
              onChangeAddTypesToOrganisationModalVisible={
                onChangeAddTypesToOrganisationModalVisible
              }
              assignTypesToOrganisationModalVisible={
                assignTypesToOrganisationModalVisible
              }
              setOrganisationCaseLawDocumentTypeData={
                setOrganisationCaseLawDocumentTypeData
              }
              caseLawDocumentTypes={caseLawDocumentTypes}
            />
          </Spin>
        }
      </Page>
    );
  }
}
